export default "//yastatic.net/s3/distribution/pythia/frontend/_/9811c28d62501b3edfce416288d87178.png";